'use client';

import { Flex, Link, For, Box } from "@chakra-ui/react";

export default function ColorMenu({ menu }) {
  const width = 113.56;
  const height = 46.21;

  const w = 160;
  const h = (height / width) * w;

  function svg(color = '#ccc') {
    const theSvg = `<?xml version="1.0" encoding="utf-8"?>
      <svg version="1.1" id="Camada_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 113.56 46.21" style="enable-background:new 0 0 113.56 46.21;" xml:space="preserve">
      <style type="text/css">
        .st0{fill:${color};}
      </style>
      <path class="st0" d="M107.1,0H26.99C18.87,0,11.73,5.38,9.49,13.19L0,46.21l113.56-0.07c-6.12-0.03-10.19-5.97-8.37-11.82
        l8.08-25.95C114.56,4.22,111.45,0,107.1,0z"/>
      </svg>
    `;

    const encodedSvg = encodeURIComponent(theSvg);

    return `url("data:image/svg+xml,${encodedSvg}")`;
  }

  return (
    <Flex justifyContent="flex-end" alignItems="center">
      <For each={menu}>
        {item => (
          <Link
            href={item.href}
            key={item.label}
            title={item.label}
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            ml={item.marginLeft}
            px="4"
            pl="8"
            pr="12"
            textAlign="center"
            fontWeight="bold"
            fontStyle="italic"
            fontSize="1.0em"
            textTransform="uppercase"
            color="white"
            w={w}
            h={h}
            position="relative"
            backgroundImage={svg(item.color)}
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
            transition="all 0.3s ease"
            _before={{
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: svg('#00bdff'),
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              opacity: 0,
              transition: 'opacity 0.3s ease',
            }}
            _hover={{
              _before: {
                opacity: 1,
              },
            }}
            lineHeight="1em"
          >
            <Box as="span" position="relative" zIndex="1">
              {item.label}
            </Box>
          </Link>
        )}
      </For>
    </Flex>
  )
}
